export default __webpack_public_path__ + "static/media/koc-logo.db7dee18.svg";